<template>
    <v-layout ref="app" class="column w-100 h-100">
        <div class="header w-100">
            <v-container>
                <v-img
                    src="/images/OnflyLogoEmail.png"
                    width="200px"
                    class="mx-auto"
                />
                <div class="w-100 d-flex justify-center pt-6 pb-2">
                    <span class="page-title">{{ pageTitle }}</span>
                </div>
            </v-container>
        </div>
        <v-main>
            <router-view/>
        </v-main>
        <div class="footer">
            <v-container class="py-6">
                <div class="d-flex flex-column">
                    <div>
                        Em caso de dúvidas, entre em contato conosco:
                    </div>
                    <div class="mt-4">
                        <v-icon color="white">mdi-phone</v-icon>
                        Telefone: (31) 3181-0456
                    </div>
                    <div class="mt-2">
                        <v-icon color="white">mdi-email</v-icon>
                        E-mail: <a href="mailto:atendimento@onfly.com.br"
                                   class="footer-link">atendimento@onfly.com.br</a>
                    </div>
                </div>
                <v-row justify="space-between" align="center" class="mt-5 pe-3 w-100">
                    <v-col cols="12" sm="3">
                        <v-img
                            src="/images/OnflyLogoEmailFooter.png"
                            :width="$vuetify.breakpoint.smAndDown? '18em' : '30em'"
                            max-width="350px"
                        />
                    </v-col>
                    <v-col cols="5" sm="3" class="pe-2" :class="$vuetify.breakpoint.smAndDown && 'ms-auto mt-3'">
                        <v-img
                            src="/images/fly-email.png"
                            width="10em"
                            class="ms-auto"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-layout>
</template>
<script>
export default {
    name: "FormLayout",
    computed: {
        pageTitle() {
            return this.$route.meta.title;
        }
    }
}
</script>
<style lang="scss" scoped>
.header {
    color: white;
    background-color: #009efb;
}
.page-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
}
.footer {
    background-color: #999999;
    color: #f0f0f0;
    padding: 32px;
    justify-self: end;
}
:deep(.v-image__image--cover) {
    background-size: contain;
}
</style>
